module.exports = __webpack_public_path__ + "media/images/help/schedule_monthly-f692125216a37110891487f3c92fb830.png";